import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';

import {environment} from '../environments/environment';
import {metaReducers} from './main/common/redux/local.storage.sync';
import {generalReducer} from './main/common/redux/general.reducers';
import {GeneralEffects} from './main/common/redux/general.effects';
import {IsLoggedGuard} from './main/common/guards/isLogged.guard';

const appRoutes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('./main/authentication/authentication.module').then(m => m.AuthenticationModule)
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./main/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'consignmentNotes',
        loadChildren: () => import('./main/consignment-notes/consignment-notes.module').then(m => m.ConsignmentNotesModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'informations',
        loadChildren: () => import('./main/informations/informations.module').then(m => m.InformationsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'informationBlocks',
        loadChildren: () => import('./main/information-blocks/information-blocks.module').then(m => m.InformationBlocksModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'payment',
        loadChildren: () => import('./main/payment-credits/payment-credits.module').then(m => m.PaymentCreditsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'liquidations',
        loadChildren: () => import('./main/liquidations/liquidations.module').then(m => m.LiquidationsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'banks',
        loadChildren: () => import('./main/banks/banks.module').then(m => m.BanksModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'attentionCustomers',
        loadChildren: () => import('./main/attention-customers/attention-customers.module').then(m => m.AttentionCustomersModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'remissions',
        loadChildren: () => import('./main/remissions/remissions.module').then(m => m.RemissionsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'invoices',
        loadChildren: () => import('./main/invoices/invoices.module').then(m => m.InvoicesModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'debitNotes',
        loadChildren: () => import('./main/debit-notes/debit-notes.module').then(m => m.DebitNotesModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'complements',
        loadChildren: () => import('./main/complements/complements.module').then(m => m.ComplementsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'creditNotes',
        loadChildren: () => import('./main/credit-notes/credit-notes.module').then(m => m.CreditNotesModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'customers',
        loadChildren: () => import('./main/customers/customers.module').then(m => m.CustomersModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'branchOffices',
        loadChildren: () => import('./main/branch-offices/branch-offices.module').then(m => m.BranchOfficesModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'providers',
        loadChildren: () => import('./main/providers/providers.module').then(m => m.ProvidersModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'operators',
        loadChildren: () => import('./main/operators/operators.module').then(m => m.OperatorsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'persons',
        loadChildren: () => import('./main/persons/persons.module').then(m => m.PersonsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'trailers',
        loadChildren: () => import('./main/trailers/trailers.module').then(m => m.TrailersModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'trucks',
        loadChildren: () => import('./main/trucks/trucks.module').then(m => m.TrucksModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'products',
        loadChildren: () => import('./main/products/products.module').then(m => m.ProductsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'catalogs',
        loadChildren: () => import('./main/catalogs/catalogs.module').then(m => m.CatalogsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'users',
        loadChildren: () => import('./main/users/users.module').then(m => m.UsersModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'roles',
        loadChildren: () => import('./main/roles/roles.module').then(m => m.RolesModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'configurations',
        loadChildren: () => import('./main/configurations/configurations.module').then(m => m.ConfigurationsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
    },
    {
        path: 'localTravels',
        loadChildren: () => import('./main/local-travels/local-travels.module').then(m => m.LocalTravelsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    {
        path: 'foreingTravels',
        loadChildren: () => import('./main/foreing-travels/foreing-travels.module').then(m => m.ForeingTravelsModule),
        canActivate: [IsLoggedGuard],
        canLoad: [IsLoggedGuard]
    },
    // {
    //     path: '**',
    //     redirectTo: '/pages/miscellaneous/error' // Error 404 - Page not found
    // }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
            scrollPositionRestoration: 'enabled',
            relativeLinkResolution: 'legacy'
        }),
        StoreModule.forRoot({general: generalReducer}, {metaReducers}),
        EffectsModule.forRoot([GeneralEffects]),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {

}
